import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Arrow from "assets/icons/Arrow-down-gray-png.png";
import { CheckBox } from "components/CheckBox/CheckBox";
import { Counter } from "components/Counter/Counter";
import { numberFormat } from "helper/numberFormat";
import React from "react";

import { SolidLine } from "../Theme";
import {
  FirstDiv,
  FlexItem,
  FlexItemsContainer,
  ProductContent,
  SecondDiv,
  SelectWrapper,
  Title,
  VarientAmount,
  Wrapper,
} from "./Theme";
import { getAuthenticated } from "utils/functions";
import { Fonts, FontColors } from "theme/fontConfig";

const useStyles = makeStyles(() => ({
  formControl: {
    "& .MuiInputBase-root": {
      display: "flex",
      justifyContent: "left",
      width: "100%",
      border: 0,
    },

    "& .MuiSelect-select.MuiSelect-select": {
      paddingRight: "0px !important",
    },
  },
  select: {
    display: "flex",
    justifyContent: "left",
    width: "100% !importent",
    fontSize: Fonts.GeneralCaptionFont.fontSize,

    "&:focus": {
      border: 0,
    },
    "&:hover": {
      border: 0,
    },
  },
  selectIcon: {
    position: "relative",
    color: FontColors.Blue002E5C,
    fontSize: "14px",
    opacity: 0.4,
  },
  paper: {
    borderRadius: 12,
    marginTop: 8,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    "& li": {
      fontWeight: Fonts.GeneralCaptionFont.fontWeight,
      paddingTop: 8,
      paddingBottom: 8,
      fontSize: Fonts.GeneralCaptionFont.fontSize,
    },
    "& li.Mui-selected": {
      color: FontColors.Blue002E5C,
      background: "##F4F6F9",
    },
    "& li.Mui-selected:hover": {
      background: "##F4F6F9",
    },
  },
}));

const Products = ({
  productsData,
  incrementProductCounter,
  decrementProductCounter,
  selectProductVariant,
}) => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const classes = useStyles();
  const menuProps = {
    classes: {
      list: classes.list,
      paper: classes.paper,
    },
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center",
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center",
    },
    getContentAnchorEl: null,
  };

  return (
    <Wrapper>
      {productsData?.map((product, productIndex) => {
        return (
          <>
            <ProductContent>
              <FirstDiv totalProducts={true} style={{ paddingTop: "10px" }}>
                <FlexItemsContainer>
                  <FlexItem>
                    {product?.limitType === "checkbox" ? (
                      <CheckBox
                        text={product?.title}
                        onChange={(e) => {
                          if (e.target.checked) {
                            incrementProductCounter(product._id);
                          } else {
                            decrementProductCounter(product._id);
                          }
                        }}
                        checked={product?.counter > 0}
                      />
                    ) : (
                      <Title>{product?.title}</Title>
                    )}
                  </FlexItem>
                  <FlexItem>
                    {product?.limitType !== "checkbox" && (
                      <Counter
                        key={product._id}
                        product={product}
                        counter={product?.counter || 0}
                        handleClickIncrement={() => {
                          incrementProductCounter(product._id);
                        }}
                        handleClickDecrement={() => {
                          decrementProductCounter(product._id);
                        }}
                      />
                    )}
                  </FlexItem>
                </FlexItemsContainer>
              </FirstDiv>

              <SecondDiv>
                {product?.counter > 0 && product?.variant && (
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    style={{ gap: "10px" }}
                  >
                    {Array.from({ length: product?.counter }).map(
                      (_, dropdownIndex) => (
                        <SelectWrapper>
                          <VarientAmount>
                            {product?.selectedVariants[dropdownIndex]
                              ? `${numberFormat({
                                  number:
                                    product?.variantInfo?.find(
                                      (variant) =>
                                        variant.name ===
                                        product?.selectedVariants[dropdownIndex]
                                    )?.amount || 0,
                                  decimal: 2,
                                  style: "currency",
                                })}`
                              : ""}
                          </VarientAmount>

                          <Select
                            displayEmpty
                            onChange={(e) => {
                              const { value } = e.target;
                              selectProductVariant(
                                value,
                                product._id,
                                dropdownIndex
                              );
                            }}
                            value={
                              product?.selectedVariants[dropdownIndex] || ""
                            }
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            IconComponent={() => (
                              <img
                                src={Arrow}
                                alt="Custom Arrow"
                                style={{
                                  width: "12px",
                                  height: "6.4px",
                                  marginRight: 20,
                                  position: "absolute",
                                  right: 0,
                                }}
                              />
                            )}
                            MenuProps={menuProps}
                            classes={{
                              select: classes.select,
                              icon: classes.selectIcon,
                            }}
                          >
                            <MenuItem disabled value="">
                              <em>Select</em>
                            </MenuItem>
                            {product?.variantInfo?.map((option, index) => (
                              <MenuItem
                                key={option?.name}
                                value={option?.name}
                                disabled={
                                  option?.quantity === option?.counterVariant ||
                                  (option?.forMemberOnly && !isAuth)
                                }
                                className="d-flex align-items-center justify-content-between"
                              >
                                <div
                                  className="d-inline-flex"
                                  style={{
                                    gap: "5px",
                                  }}
                                >
                                  {option?.name}{" "}
                                  {option?.forMemberOnly && !isAuth && (
                                    <span>(Members Only)</span>
                                  )}
                                </div>
                                <span
                                  style={{
                                    marginLeft: "5px",
                                  }}
                                >
                                  {numberFormat({
                                    number: option?.amount,
                                    decimal: 2,
                                    style: "currency",
                                  })}
                                </span>
                              </MenuItem>
                            ))}
                          </Select>
                        </SelectWrapper>
                      )
                    )}
                  </FormControl>
                )}
              </SecondDiv>
            </ProductContent>
            <SolidLine />
          </>
        );
      })}
    </Wrapper>
  );
};

export default Products;
